var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32483",
    d: "M97.4,90.7c-3.3-17.1-15-31.3-31.1-37.8c-9.9,5.9-22.2,5.9-32,0C18.1,59.4,6.3,73.6,3,90.7 c-0.6,2.8-2.3,9.3,6.3,9.3h81.7C99.7,100,98,93.5,97.4,90.7z M50.1,50.2c13.9,0,25.1-11.2,25.1-25.1C75.2,11.2,64,0,50.1,0 C36.2,0,25,11.2,25,25.1C25,38.9,36.2,50.2,50.1,50.2C50.1,50.2,50.1,50.2,50.1,50.2L50.1,50.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.80a774b1cb62b6fa4914f0db909ede11.svg";
export { ForwardRef as ReactComponent };